export default __webpack_public_path__ + "static/media/bus.ad23cb61.svg";